<template>
  <div>
    <NBar title="启动页标题" :top="true"/>
    <div class="subject">
      <div class="title" v-if="addressList.length == 1 && addressList[0].id == 0">默认设置</div>
      <div class="title" v-else>场地名称:{{addressList[0].name}}</div>
      <div class="title" v-if="addressList.length > 1">您正在对{{addressList.length}}个场地进行页面标题的设置</div>
      <nut-textinput v-model="form.startTitle" placeholder="请输入标题名称，如“乐呵呵娱乐(万达店)”" :clearBtn="false" :disabled="false"
                     class="input"/>
      <nut-button block class="btn" @click="save">保存</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleSet',
  props: ['type', 'data'],
  data () {
    return {
      user: {},
      addressList: [{}],
      form: {
        id: null,
        addressIds: [],
        merId: null,
        storeId: null,
        startTitle: ''
      },
    }
  },
  mounted () {
    this.form.merId = this.$api.merId
    this.form.storeId = this.$api.storeId
    this.user = this.$api.user
    if (this.data != null) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.addressList = data
      this.addressList.forEach(item => {
        this.form.addressIds.push(item.id)
      })
      if (this.addressList.length == 1) {
        this.getData()
      }
    }
  },
  methods: {
    getData: function () {
      this.$api.post({
        url: '/device/api/system/device-address-system-set/find',
        data: {
          merId: this.user.merId,
          storeId: this.user.storeId,
          addressId: this.addressList[0].id
        }
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.$util.ofData(this.form, res.data)
        }
      })
    },
    //提交评论
    save: function () {
      if (this.$util.isArrOrNull(this.form.startTitle)) {
        this.$toast.warn('请输入最少1个字的标题')
        return
      }
      this.$api.post({
        url: '/device/api/system/device-address-system-set/save',
        data: this.form
      }).then(() => {
        setTimeout(() => {
          if (this.type != null) {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        }, 2000)
      })
    },
  }
}
</script>

<style scoped>
  .subject {
    margin: 0 15px;
  }

  .subject .title {
    height: 35px;
    line-height: 35px;
    margin-top: 5px;
    color: #848484;
  }

  .subject .input {
    margin: 5px 0;
  }

  .subject .btn {
    margin-top: 10px;
    border-radius: 5px;
  }

  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-imagepicker .img-list .add-icon {
    border: 1px dashed #409EFF;
  }

  >>> .nut-imagepicker .img-list .add-icon i {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/TitleSet.vue